import * as Sentry from '@sentry/react';
import {
  Modal,
  ModalActions,
  ModalContent,
  Prose,
  Pushbutton
} from '@stratumn/atomic';
import to from 'await-to-js';
import { expireKey } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

export const ExpireKeyModal = ({
  environment,
  keyName,
  keyObj,
  toggleModal
}) => {
  const [submitted, setSubmit] = useState(false);

  const expireKeyFn = () => {
    withSpanAsync('expireKey', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(expireKey(environment, keyObj.rowId));

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        toggleModal();
      }

      return {};
    });
  };

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={toggleModal}
      title="Expire Signing Key"
    >
      <ModalContent>
        <Prose
          light
          text={`This action will definitively deprecate signing key **${
            keyName || keyObj.rowId
          }**. It will not be possible to sign with it afterwards.`}
        />
      </ModalContent>
      <ModalActions>
        <Pushbutton data-testid="cancel-button" onClick={toggleModal}>
          cancel
        </Pushbutton>
        <Pushbutton
          data-testid="expire-button"
          disabled={submitted}
          onClick={expireKeyFn}
          warning
        >
          Expire
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

ExpireKeyModal.propTypes = {
  environment: PropType.object.isRequired,
  keyName: PropType.string,
  keyObj: PropType.object.isRequired,
  toggleModal: PropType.func.isRequired
};
ExpireKeyModal.defaultProps = {
  keyName: ''
};

export default withGqlClient(ExpireKeyModal);
